import { render, staticRenderFns } from "./ImageContent.vue?vue&type=template&id=15a48c1d"
import script from "./ImageContent.vue?vue&type=script&lang=js"
export * from "./ImageContent.vue?vue&type=script&lang=js"
import style0 from "./ImageContent.vue?vue&type=style&index=0&id=15a48c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports